import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../utils/AxiosUtil';
import * as dateUtil from '../../../common/filters/DateUtil';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';

const f = new Intl.DateTimeFormat('hu');

class Address extends Component {
    fields = ['address', 'validFrom'];

    state = {
        customerId: this.props.row.privateId,
        addresses: [],
        address: "",
        validFrom: new Date(),
        errors: new Map(),
        first: {}
    };

    componentDidMount() {
        console.log(this.props.row);
        this.callAddressApi(this.props.row.privateId)
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    enrich = (data) => {
        data.map((item) => {
            item.validFromDate = (item.validFrom) ? f.format(new Date(item.validFrom)) : "";
            item.validUntilDate = (item.validUntil) ? f.format(new Date(item.validUntil)) : "";
            return item;
        })
        let firstElement = data.splice(0, 1).pop();
        if (firstElement) {
            this.setState({ first: firstElement });
        }
        this.setState({ addresses: data })
    }

    callAddressApi = async (id) => {
        const path = `/api/customer/address/${id}`;
        const response = await axios.get(path);
        if (response.status !== 200) throw Error(response.message);
        return response;
    };

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/customer/address';
        const requestObject = {
            "customerId": this.state.customerId,
            "address": this.state.address,
            "validFrom": this.state.validFrom
        };
        await handlePost(path, requestObject, this);
    };

    handleAddressChange = (e, this2) => {
        if (e.target && e.target.value && this.state.first.privateId) {
            const newValidUntil = dateUtil.getYesterday(new Date(this.state.validFrom));
            let m = this.state.first;
            m.validUntil = newValidUntil;
            m.validUntilDate = f.format(newValidUntil);
            this.setState({ first: m });
        }
        handleChangeEvent(e, this2);
    }

    handleValidUntilChange = (e) => {
        if (this.state.address && this.state.first.privateId) {
            const newValidUntil = dateUtil.getYesterday(e);
            let m = this.state.first;
            m.validUntil = newValidUntil;
            m.validUntilDate = f.format(newValidUntil);
            this.setState({ first: m });
        }
        this.setState({ validFrom: e });
    }

    getMinDate = () => {
        if (this.state.first.validFrom) {
            return dateUtil.getTomorrow(new Date(this.state.first.validFrom));
        }
    }

    getClass = () => {
        if (this.state.address) {
            return "newly-added";
        } else {
            return "";
        }
    }

    getBody() {
        return (
            <TableBody>
                {(this.state.address) ?
                    <TableRow key="new" className="newly-added">
                        <TableCell > {this.state.address}</TableCell>
                        <TableCell align="right">{f.format(this.state.validFrom)}</TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                    : <></>}
                {(this.state.first) ?
                    <TableRow key={this.state.first.privateId}>
                        <TableCell > {this.state.first.address}</TableCell>
                        <TableCell align="right">{this.state.first.validFromDate}</TableCell>
                        <TableCell align="right" className={this.getClass()}>{this.state.first.validUntilDate}</TableCell>
                    </TableRow>
                    : <></>}
                {this.state.addresses.map((row) => (
                    <TableRow key={row.privateId}>
                        <TableCell > {row.address}</TableCell>
                        <TableCell align="right">{row.validFromDate}</TableCell>
                        <TableCell align="right">{row.validUntilDate}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        )
    }

    render() {
        return (
            <>
                <h3>Eddigi címek</h3>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Cím</TableCell>
                                <TableCell align="right">Érvényes -től</TableCell>
                                <TableCell align="right">Érvényes -ig</TableCell>
                            </TableRow>
                        </TableHead>
                        {this.getBody()}
                    </Table>
                </TableContainer>
                <h3>Új cím</h3>
                <form onSubmit={this.handleSubmit}>
                    <div className='flex-form'>
                        <div className='input-group'>
                            <ErrorAwareTextField
                                name="address"
                                label="Cím"
                                errors={this.state.errors}
                                value={this.state.address}
                                onChange={e => this.handleAddressChange(e, this)} />
                        </div>
                        <div className='input-group'>
                            <ErrorAwareDatePicker
                                name="validFrom"
                                label="Érvényesség kezdete"
                                errors={this.state.errors}
                                value={this.state.validFrom}
                                minDate={this.getMinDate()}
                                onChange={event => this.handleValidUntilChange(event)} />
                        </div>
                    </div>
                    <div className="form-actions">
                        <Button className="btn-submit" variant="contained" color="primary" onClick={this.props.close}>
                            Mégse
                        </Button>
                        <Button className="btn-submit" variant="contained" color="primary" type="submit">
                            Mentés
                        </Button>
                    </div>
                </form>
            </>
        )
    }
}

export default withSnackbar(Address);
